import { request } from '@/utils/api-request'

export function getReviewList (params) {
  const url = '/api/admin/review/list'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function getReviewInfo (params) {
  const url = '/api/admin/review/info'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function updateCategoryList (params) {
  const url = '/api/admin/category/update'

  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}
